<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">

    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div #extContainer
           class="inner wrap flex-column">

        <app-search-box #extHeader
                        [keyword]="keyword"
                        [placeholder]="placeholder"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_DIALECT"
                        [keyHistoryView]="HISTORY_KEY_VIEW_DIALECT"
                        [top]="scrollTop"
                        (search)="onSearch($event)"
                        (goHistory)="onGoHistory()"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout">

            <div #extBody2
                 class="book-layout-wrap">

              <div class="book-page-list">

                <app-jaso-index [curJasoIdx]="curJasoIdx"
                                [second]="true"
                                (search)="onSearch($event)"></app-jaso-index>

                <div #extBody
                     class="book-page-group">

                  <div class="page-box {{ isNoResult() ? 'empty' : '' }}">
                    <div #container
                         (scroll)="onScroll($event)"
                         class="page-contents scroll-effect over-y">

                      <article class="result-list-layout1"
                               [class.empty]="isNoResult()"
                               [class.dialect]="isNoResult()"
                               style="padding-bottom: 20px;">
                        <div #innerScroll
                             class="list-wrap">

                          <div class="region-box main-type{{ GetRegion2Css(selectedRegion) }}">
                            <div class="subject-txt"
                                 [innerHTML]="regionTitle | resize | keepHtml"></div>
                          </div>

                          <ul class="dialect">

                            <li *ngFor="let dialect of ll?.getList(); let idx = index">
                              <app-dialect-item class="item-box"
                                                id="{{ listItemId(dialect.id) }}"
                                                [dialect]="dialect"
                                                (viewInit)="onChildViewInit($event)"
                                                (click)="onSelectDialect($event, dialect.id)">
                              </app-dialect-item>
                            </li>


                            <li class="reload-icon" *ngIf="ll && !ll.IsComplete()">
                              <img #reload src="assets/img/loading_icon.gif">
                            </li>

                            <li class="no-result" *ngIf="isNoResult()">
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">우리말이 없습니다.</div>
                            </li>

                          </ul>
                        </div>
                      </article>

                    </div>

                  </div>
                  <div class="page-box {{ isNoResult() ? 'empty' : '' }}">

                    <!-- 도움말 -->
                    <!-- app-word-help-btn></app-word-help-btn -->

                    <!-- app-word-detail *ngIf="curDetailWord"
                                     [word_id]="curDetailWord"
                                     [autoPlay]="autoPlay"></app-word-detail -->

                    <app-dialect-detail *ngIf="curDetail"
                                        class="page-contents over-y scroll-effect"
                                        [dialect_id]="curDetail"
                                        (bookmarkChange)="onBookmarkChange($event)"></app-dialect-detail>

                  </div>

                  <div *ngIf="showScrollDown"
                       class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>

  </div>


  <!-- app-footer></app-footer -->

  <app-common-popups></app-common-popups>

</div>
